import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../../stores/root';
import CustomersList from '../../../components/users/customers/general/list';
import { faHome } from '@fortawesome/pro-light-svg-icons';

interface ICustomersListPageProps {
}

const CustomersListPage: React.FC<ICustomersListPageProps> = (props: ICustomersListPageProps) => {
    const {topbar} = useStore();

    useEffect(() => {
        topbar.show("Customers", [
            {key: "home", icon: faHome, href: "/"},
            {key: "users", text: 'Users'},
            {key: "customers", text: 'Customers'}
        ])
    }, []);

    return <Stack>
        <CustomersList />
    </Stack>;
};

export default CustomersListPage;
